/**
 * Checks if Office SSO (OfficeRuntime.auth.getAccessToken) is supported in the current host.
 */
export const getIsSSOSupported = (): boolean => {
  // Check if the IdentityAPI requirement set is supported
  // https://learn.microsoft.com/en-us/javascript/api/requirement-sets/common/identity-api-requirement-sets?view=word-js-preview
  const isIdentityAPISupported = Office.context.requirements.isSetSupported('IdentityAPI', '1.3');

  // Also defensively check if the function actually exists
  const hasGetAccessToken =
    typeof OfficeRuntime !== 'undefined' &&
    OfficeRuntime.auth &&
    typeof OfficeRuntime.auth.getAccessToken === 'function';

  return isIdentityAPISupported && hasGetAccessToken;
};
